import URC from 'ui-react-common';
import LoanPurpose from './loan-purpose/LoanPurpose';
import HomeOwnership from './home-ownership/HomeOwnership';
import Address from './address/Address';
import FirstName from './first-name/FirstName';
import LastName from './last-name/LastName';
import Recaptcha from './recaptcha/Recaptcha';
import DeviceFingerprint from './device-fingerprint/DeviceFingerprint';
import SSNLast4 from './ssn-last4/SSNLast4';
import Password from './password/Password';

const { Disclosures, EmploymentStatus, ContinueButton } = URC.ui.components.forms.configured;
const { disclosureTypes } = Disclosures;

const components = {
    disclosures: {
        Disclosures,
        disclosureTypes,
    },
    LoanPurpose,
    HomeOwnership,
    Address,
    FirstName,
    LastName,
    Recaptcha,
    EmploymentStatus,
    SSNLast4,
    DeviceFingerprint,
    ContinueButton,
    Password
};

export default components;
